import { patientsApi } from './index'

export default patientsApi.middleware
